export const MAIN_MENU_ID = 'main-menu-dropdown';
export const SECONDARY_MENU_ID = 'secondary-menu-dropdown';
